import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { useState, useEffect, useRef } from "react";
import {  IconButton, Modal, Box, Dialog, DialogActions,InputAdornment,TextField, DialogContent, DialogTitle, Grid, Card, CardContent, TextareaAutosize } from '@mui/material';
import Table from 'react-bootstrap/Table';
import {ButtonGroup, ToggleButton} from "react-bootstrap";
import {Button} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "layouts/style.css"
import { ToastContainer,toast } from "react-toastify";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import {Checkbox} from "@mui/material";
import { fetchAllVendors } from "assets/globalAPI/apiGlobal";
import { saveVendorForm1 } from "assets/globalAPI/apiGlobal";
import { approveVendor } from "assets/globalAPI/apiGlobal";
import { saveVendorPortalForm1 } from "assets/globalAPI/apiGlobal";
import LoadingOverlay from "react-loading-overlay";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchKDSVendor } from "assets/globalAPI/apiGlobal";
import {Typography} from "@mui/material";
import { fetchAuditLog } from "assets/globalAPI/apiGlobal";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: 250,
    minHeight: 30,
    fontSize: "0.9rem",
    borderColor: state.isFocused ? "red" : provided.borderColor, // Change border color to red on focus
    boxShadow: state.isFocused ? "0 0 0 2px red" : "none", // Remove blue focus outline and apply red
    "&:hover": {
      borderColor: "red",
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.85rem",
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "0.85rem",
    padding: 8,
    backgroundColor: state.isSelected ? "red" : provided.backgroundColor, // Change selected option to red
    color: state.isSelected ? "white" : provided.color, // Ensure text visibility
    "&:hover": {
      backgroundColor: "red", // Change hover effect to red
      color: "white",
    },
  }),
};
const VendorsList = () => {
  const navigate= useNavigate();
    const toastId= useRef(null)
    const [openModal, setOpenModal] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openComment, setOpenComment] = useState(false);
    const [openComment2, setOpenComment2] = useState(false);
    const [openComment3, setOpenComment3] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [comment,setComment]= useState("");
    const [openApproverDialog, setOpenApproverDialog]= useState(false)
    // const [openDialog, setOpenDialog] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isDept, setIsDept] = useState(false);
    const [isAcc, setIsAcc] = useState(false);
    const [isIT, setIsIT] = useState(false);
    const [isMDM, setIsMDM] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [approvalAllowed, setApprovalAllowed] = useState(false);
    const [editAllowed, setEditAllowed] = useState(false);
    const [approvalStatus, setApprovalStatus]= useState("");
    const [currentPage,setCurrentPage]= useState(1);
    const [totalPages,setTotalPages]= useState(1);
    const [vendors, setVendors]= useState([]);
    const [vendorStatus, setVendorStatus]= useState("")
    const [userRoleId, setuserRoleId]= useState(0);
    const [approvalData, setApprovalData]= useState([])
    const [lastApprover, setLastApprover]= useState([])
     const [selectedTab, setSelectedTab]= useState('details')
    const [allApproveDetails, setAllApproveDetails]= useState([])
    const [allAuditLogs, setAllAuditLogs]= useState([])
    const [roledetails,setRoleDetails]= useState({});
    const [searchTerm, setSearchTerm] = useState("");
     const typingTimeoutRef = React.useRef(null);
      const latestSearchRef = React.useRef("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [vendorSearch,setVendorSearch]= useState("");
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [userID, setUserID]= useState("")
    const [refID, setRefID]= useState("");
    const [filter, setFilter] = useState("all");
    const [selectedStatus,setSelectedStatus]= useState("pending")
    const [selectedField, setSelectedField] = useState("");
    const [keySelected,setKeySelected]= useState('');
    const [indexSelected,setIndexSelected]= useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogOpen2, setDialogOpen2] = useState(false);
    const [kdsdata,setKdsData]=useState({});

     const [formValues, setFormValues] = useState({
          reference_id: {value: '', error: false},
          nature_of_business: { value: [],error: false }, // Nature of Business*
          business_category: { value: [],error: false }, // Business Category
          tds_exemption: { value: '',error: false }, // TDS Exemption/Lower Deduction
          tds_nature_of_service: { value: '',error: false }, // Nature of Service for TDS
          tds_section: { value: '',error: false }, // TDS to be Deducted u/s,
          search_term_1: {value:'', error:false},
          search_term_2: {value:'', error:false},
          bp_grouping: {value:'', error:false},
          language: {value: 'EN', error: false},
          telephone: {value: '', error: false},
          cst_no: {value: '', error: false},
          lst_no: {value: '', error: false},
          contact_allowance: {value:'', error:false},
          district: {value:'', error:false},
          po_box: {value:'', error:false},
          region: {value:'', error:false},
          company_code: {value:'', error:false},
          co_name: {value:'', error:false},
          reconciliation_account: {value: '', error: false},
          sort_key: {value: '001', error: false},
          payment_terms: {value: '', error: false},
          payment_methods: {value: '', error: false},
          bank_key: {value: '', error: false},
          account_holder_name: {value: '', error: false},
          abc_indicator: {value: '', error: false},
          withholding_subject: {value: '', error: false},
          withholding_subject_2: {value: '', error: false},
          purchase_organization: {value: '', error: false},
          gr_based_invoice_verification: {value: '', error: false},
          service_based_invoice_verification: {value: '', error: false},
          withholding_tax_type: {value: '', error: false},
          withholding_tax_type_2: {value: '', error: false},
          withholding_tax_code: {value: '', error: false},
          withholding_tax_code_2: {value: '', error: false},
          tax_type: {value: '', error: false},
          tax_type_2: {value: '', error: false},
          tax_type_3: {value: '', error: false},
          tax_type_4: {value: '', error: false},
          // tax_type_5: {value: 'IN5', error: false},
          tax_number: {value: '', error: false},
          tax_number_2: {value: '', error: false},
          tax_number_3: {value: '', error: false},
          tax_number_4: {value: '', error: false},
          tax_number_5: {value: '', error: false},
          recipient_type: {value: '', error: false},
          recipient_type_2: {value: '', error: false},
          order_currency: {value: '', error: false},
          vendor_schema: {value: 'Z1', error: false},
          pan_card_submitted: {value: '', error: false},
          food_license_submitted: {value: '', error: false},
          gstin_submitted: {value: '', error: false},
          tds_details: [
            {
              section_code: "",
              exemption_number: "",
              exemption_rate: "",
              exemption_from: "",
              exemption_to: "",
              exemption_reason: "",
              withholding_tax_type_3: "",
              withholding_tax_code_3: "",
              exemp_threshold: "",
              currency: ""
            }
          ]
        });

        const fieldDisplayNames = {
          "reference_id": "Reference ID",
          "trade_name": "Trade Name (as per GST)*",
          "street": "Street Address (to be registered as per GST)*",
          "house_no": "House No.",
          "type_of_firm": "Type of Firm/Company*",
          "cin": "CIN (if applicable)",
          "mca_roc_status": "MCA/ROC Status (for Co/LLP)",
          "city": "City*",
          "state": "State*",
          "pin_code": "Pin Code*",
          "website": "Website",
          "proprietor_name": "Proprietor Name",
          "proprietor_email": "Proprietor Email",
          "proprietor_mobile": "Proprietor Mobile",
          "pan": "PAN",
          "contact_person": "Contact Person Name*",
          "contact_person_email": "Contact Person Email*",
          "contact_person_mobile": "Contact Person Mobile*",
          "contact_telephone": "Contact Telephone",
          "nature_of_business": "Nature of Business*",
          "business_category": "Business Category",
          "tds_exemption": "TDS Exemption/Lower Deduction",
          "tds_nature_of_service": "Nature of Service for TDS",
          "tds_section": "TDS to be Deducted u/s",
          "msme_registration_status": "MSME Registration Status",
          "msme_registration_no": "MSME Registration No.",
          "msme_category": "MSME Category",
          "msme_type": "MSME Type",
          "fssai_registration_status": "FSSAI Registration Status",
          "fssai_regn_no": "FSSAI Regn No",
          "fssai_valid_till": "FSSAI Valid Till (dd-mm-yyyy)",
          "gstn": "GSTN No*",
          "tan": "TAN*",
          "itr_filing_status": "Status of Filing ITR of Last 2 Years",
          "pan_linked_aadhaar": "PAN Linked with Aadhaar",
          "gst_turnover_prev_yr": "GST Turnover of Previous Year (Lakhs)",
          "e_invoice_applicable": "E-Invoice Applicable",
          "bank_name": "Bank Name",
          "ifsc_code": "IFSC Code",
          "bank_account_number": "Bank Account Number",
          "cheque_number": "Cheque Number",
          "cheque_issued_name": "Cheque Issued Name",
          "date_of_fillup": "GSTN Document*",
          "approval_status": "Approval Status",
          "search_term_1": "Search Term 1",
          "search_term_2": "Search Term 2",
          "bp_grouping": "BP Grouping",
          "language": "Language",
          "telephone": "Telephone",
          "cst_no": "CST No.",
          "lst_no": "LST No.",
          "contact_allowance": "Contact Allowance",
          "district": "District",
          "po_box": "PO Box",
          "region": "Region",
          "company_code": "Company Code",
          "co_name": "Company Name",
          "reconciliation_account": "Reconciliation Account",
          "sort_key": "Sort Key",
          "payment_terms": "Payment Terms",
          "payment_methods": "Payment Methods",
          "bank_key": "Bank Key",
          "account_holder_name": "Account Holder Name",
          "abc_indicator": "ABC Indicator",
          "withholding_subject": "Withholding Subject",
          "withholding_subject_2": "Withholding Subject 2",
          "purchase_organization": "Purchase Organization",
          "gr_based_invoice_verification": "GR Based Invoice Verification",
          "service_based_invoice_verification": "Service Based Invoice Verification",
          "withholding_tax_type": "Withholding Tax Type",
          "withholding_tax_type_2": "Withholding Tax Type 2",
          "withholding_tax_code": "Withholding Tax Code",
          "withholding_tax_code_2": "Withholding Tax Code 2",
          "tax_type": "Tax Type",
          "tax_type_2": "Tax Type 2",
          "tax_type_3": "Tax Type 3",
          "tax_type_4": "Tax Type 4",
          "tax_number": "Tax Number",
          "tax_number_2": "Tax Number 2",
          "tax_number_3": "Tax Number 3",
          "tax_number_4": "Tax Number 4",
          "tax_number_5": "Tax Number 5",
          "recipient_type": "Recipient Type",
          "recipient_type_2": "Recipient Type 2",
          "order_currency": "Order Currency",
          "vendor_schema": "Vendor Schema",
          "pan_card_submitted": "PAN Card Submitted",
          "food_license_submitted": "FSSAI License",
          "gstin_submitted": "GSTIN Submitted",
          "tds_details": "TDS Details"
        };
        


  const capitalizeHeader = (header) => {
    return header
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

  const fetchVendors=async(status)=>{
    setIsActive(true)
    let body;
    let userDet= JSON.parse(localStorage.getItem("userdetails"));
    let detId= userDet.id;
if(status!==""&&status!==null&& status!==undefined){
      body={
        page:1,
        vendor_status:status,
        search: latestSearchRef.current,
        userID: detId
      }
}else{
    body={
      page: latestSearchRef.current==""? currentPage:1,
      vendor_status:selectedStatus,
      search: latestSearchRef.current,
      userID: detId
    }

}
console.log("vendor fetch body>>> ", body)
    
    try{
      const response= await fetchAllVendors(body);
      const res= response.data;
      if(res.status){
        console.log("Vendors fetched>> ", res);
        setVendors(res.data);
        setTotalPages(res.totalPages)
        setIsActive(false)
      }else{
        console.log("Could not fetch vendors>> ", res);
        setVendors([]);
        setTotalPages(1)
        setIsActive(false)
      }
    }catch(err){
      console.log("Error bringing vendors>> ", err);
      setVendors([]);
      setTotalPages(1)
      setIsActive(false)
      if(err.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error(err.response.data.message,{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
      }
    }
  }

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setVendorSearch(value);
    latestSearchRef.current = value;

    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

   
typingTimeoutRef.current = setTimeout(() => {
  fetchVendors(); // Inside this function, access latest value from latestSearchRef.current
}, 2000);

   
  };

   const fetchAllVendorKDS=async()=>{
          try{
            const response= await fetchKDSVendor();
            const res= response.data;
            if(res.status){
              setKdsData(res.data);
              console.log("kds fetched>> ", res.data);
            }else{
              console.log("could not bring material kds>> ", res)
            }
          }catch(error){
            console.log("error bringing material KDS>> ", error);
          }
        }

        useEffect(() => {
            const handler = setTimeout(() => {
              setSearchLoader(true); // Show loader AFTER 2 sec pause
              setDebouncedSearch(searchTerm);
          
              // Simulate async filtering (optional delay or set false immediately after)
              setTimeout(() => {
                setSearchLoader(false); // Hide loader after data is "ready"
              }, 100); // tweak delay if needed
            }, 600); // Wait for user to stop typing
          
            return () => clearTimeout(handler); // Cleanup if typing again
          }, [searchTerm]);
        

        const filteredData = kdsdata[keySelected]?.filter(
          (item) =>
            item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
            item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
        );
  
        const handleAddRow = () => {
          setFormValues((prev) => ({
            ...prev,
            tds_details: [
              ...prev.tds_details,
              {
                section_code: "",
                exemption_number: "",
                exemption_rate: "",
                exemption_from: "",
                exemption_to: "",
                exemption_reason: "",
                withholding_tax_type_3: "",
                withholding_tax_code_3: "",
                exemp_threshold: "",
                currency: ""
              }
            ]
          }));
        };
        
        const handleRemoveRow = (indexToRemove) => {
          setFormValues((prev) => ({
            ...prev,
            tds_details: prev.tds_details.filter((_, i) => i !== indexToRemove)
          }));
        };

        
              const fetchAllVendorLogs=async(matid)=>{
                const body={
                  modulename: "Vendor",
                  recordid: matid
                }
                console.log("log body>> ", body)
                try{
                  const response= await fetchAuditLog(body);
                  const res= response.data;
                  if(res.status){
                    setAllAuditLogs(res.data);
                    console.log("logs fetched>> ", res.data);
                  }else{
                    console.log("could not bring material logs>> ", res)
                  }
                }catch(error){
                  console.log("error bringing material logs>> ", error);
                }
              }
  

  useEffect(()=>{
    fetchAllVendorKDS()
    // let localForm= localStorage.getItem("filledForm");
    // let parsedForm= JSON.parse(localForm);
    // console.log("do you have a form>> ", parsedForm)
    // if(parsedForm!==null){

    //   setFormValues(parsedForm)
    //   setApprovalStatus(parsedForm.approval_status.value)
    // }
    let msme= localStorage.getItem("msme");
    let fssi= localStorage.getItem("fssi");
    setIsMsme(JSON.parse(msme));
    setIsFssi(JSON.parse(fssi));
    const storedUser = JSON.parse(localStorage.getItem("userDetails"));
    let user_roleDetails= JSON.parse(localStorage.getItem("userRoles"));
    if(user_roleDetails){

      setApprovalAllowed(user_roleDetails[0].vendor_approval==1? true:false)
      setEditAllowed(user_roleDetails[0].vendor_edit==1? true:false)
    }
    const loggedinUser= JSON.parse(localStorage.getItem("userdetails"));
    if(loggedinUser){
    console.log("user id is>> ", loggedinUser.id)
      setUserID(loggedinUser.id)
    }
  },[]);

  useEffect(()=>{
    
    fetchVendors()
  },[currentPage])

  console.log("first and last>>> ", approvalData, lastApprover)

  
  // const vendorDetails = [
  //   {
  //     tradeName: formValues.trade_name.value || "ABC Corp",
  //     typeOfFirm: formValues.typeOfFirm.value || "LLC",
  //     city: formValues.city.value || "New York",
  //     state: formValues.state.value || "NY",
  //     email: formValues.contact_person_email.value || "contact@abccorp.com",
  //     mobile: formValues.contact_person_mobile.value || "123-456-7890",
    
  //   },
  //   // {
  //   //   tradeName: 'ABC Corp',
  //   //   typeOfFirm: 'LLC',
  //   //   city: 'New York',
  //   //   state: 'NY',
  //   //   email: 'contact@abccorp.com',
  //   //   mobile: '123-456-7890',
  //   // },
  //   // {
  //   //   tradeName: 'XYZ Ltd.',
  //   //   typeOfFirm: 'Private',
  //   //   city: 'San Francisco',
  //   //   state: 'CA',
  //   //   email: 'info@xyzltd.com',
  //   //   mobile: '987-654-3210',

  //   // },
  //   // Add more vendors as needed
  // ];

  const handlePageChange=(p)=>{
    setCurrentPage(p)
    
  }

  const filteredVendors = vendors.filter((vendor) => {
    if (filter === "approved") return vendor.approval_status.toLowerCase() === "approved";
    if (filter === "rejected") return vendor.approval_status.toLowerCase() === "rejected";
    if (filter === "pending") return vendor.approval_status.toLowerCase() === "pending";
    return true; // Show all
  });

  const validateTaxFields = () => {
    let isValid = true;
    const updatedForm = { ...formValues };
  
    for (let i = 1; i <= 4; i++) {
      const taxTypeKey = `tax_type${i === 1 ? '' : `_${i}`}`;
      const taxNumberKey = `tax_number${i === 1 ? '' : `_${i}`}`;
  
      const taxTypeVal = formValues[taxTypeKey]?.value?.trim();
      const taxNumberVal = formValues[taxNumberKey]?.value?.trim();
  
      const taxTypeFilled = !!taxTypeVal;
      const taxNumberFilled = !!taxNumberVal;
  
      // If one is filled but the other isn't, mark both with error
      if ((taxTypeFilled && !taxNumberFilled) || (!taxTypeFilled && taxNumberFilled)) {
        if (taxTypeKey in updatedForm) updatedForm[taxTypeKey].error = true;
        if (taxNumberKey in updatedForm) updatedForm[taxNumberKey].error = true;
        isValid = false;
      } else {
        if (taxTypeKey in updatedForm) updatedForm[taxTypeKey].error = false;
        if (taxNumberKey in updatedForm) updatedForm[taxNumberKey].error = false;
      }
    }
  
    setFormValues(updatedForm);
    return isValid;
  };
  
  function formatMyDate(dateTimeStr) {
    const date = new Date(dateTimeStr);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }


  const handleOpenModal = (vendor) => {
    setSelectedVendor(vendor);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedVendor(null);
  };

  const handleOpenDialog = (vendor) => {
    setAllApproveDetails(vendor.all_approver_details)
    let refHere= vendor.reference_id
    console.log("refehere>> ", refHere)
    fetchAllVendorLogs(refHere)
    const { approval_details, lastapproval_details, sap_response, sap_request,all_all_approver_details, ...filteredVendor } = vendor;
    setSelectedVendor(filteredVendor);
    console.log("my vendor is>> ", filteredVendor)
    const updatedValues = {};
    
    Object.keys(formValues).forEach((key) => {
      let parsedValue = filteredVendor[key] || '';
      if (filteredVendor.hasOwnProperty(key)) {
        let parsedValue = filteredVendor[key] || '';
    
        // Handle multi-select string to array conversion
        if (["nature_of_business", "business_category"].includes(key)) {
          parsedValue = typeof parsedValue === "string"
            ? parsedValue.trim() === ''
              ? []
              : parsedValue.split(",").map(v => v.trim())
            : parsedValue;
      
      
          console.log("here is updated business value>>> ", parsedValue);
        }
    
        updatedValues[key] = {
          ...formValues[key],
          value: parsedValue
        };
      } else {
        return;
      }
    });
    console.log("updates business values>>> ", updatedValues)
     setFormValues(updatedValues)
    setFormValues(prev => ({
      ...prev,
      reference_id: { value: filteredVendor.reference_id || '', error: false },
      // nature_of_business: { value: filteredVendor.nature_of_business || [], error: false },
      // business_category: { value: filteredVendor.business_category || [], error: false },
      tds_exemption: { value: filteredVendor.tds_exemption || '', error: false },
      tds_nature_of_service: { value: filteredVendor.tds_nature_of_service || '', error: false },
      tds_section: { value: filteredVendor.tds_section || '', error: false },
      search_term_1: { value: filteredVendor.search_term_1 || '', error: false },
      search_term_2: { value: filteredVendor.search_term_2 || '', error: false },
      bp_grouping: { value: filteredVendor.bp_grouping || '', error: false },
      language: { value: filteredVendor.language || 'EN', error: false },
      telephone: { value: filteredVendor.telephone || '', error: false },
      cst_no: { value: filteredVendor.cst_no || '', error: false },
      lst_no: { value: filteredVendor.lst_no || '', error: false },
      contact_allowance: { value: filteredVendor.contact_allowance || '', error: false },
      district: { value: filteredVendor.district || '', error: false },
      po_box: { value: filteredVendor.po_box || '', error: false },
      region: { value: filteredVendor.region || '', error: false },
      company_code: { value: filteredVendor.company_code || '', error: false },
      co_name: { value: filteredVendor.co_name || '', error: false },
      reconciliation_account: { value: filteredVendor.reconciliation_account || '', error: false },
      sort_key: { value: filteredVendor.sort_key || '001', error: false },
      payment_terms: { value: filteredVendor.payment_terms || '', error: false },
      payment_methods: { value: filteredVendor.payment_methods || '', error: false },
      bank_key: { value: filteredVendor.bank_key || '', error: false },
      account_holder_name: { value: filteredVendor.account_holder_name || '', error: false },
      withholding_subject: { value: filteredVendor.withholding_subject || '', error: false },
      withholding_subject_2: { value: filteredVendor.withholding_subject_2 || '', error: false },
      purchase_organization: { value: filteredVendor.purchase_organization || '', error: false },
      gr_based_invoice_verification: { value: filteredVendor.gr_based_invoice_verification || '', error: false },
      service_based_invoice_verification: { value: filteredVendor.service_based_invoice_verification || '', error: false },
      withholding_tax_type: { value: filteredVendor.withholding_tax_type || '', error: false },
      withholding_tax_type_2: { value: filteredVendor.withholding_tax_type_2 || '', error: false },
      withholding_tax_code: { value: filteredVendor.withholding_tax_code || '', error: false },
      withholding_tax_code_2: { value: filteredVendor.withholding_tax_code_2 || '', error: false },
      abc_indicator: {value: filteredVendor.msme_type || '', error: false},
      tax_type: { value:filteredVendor.tax_type, error: false },
      tax_type_2: { value:filteredVendor.tax_type_2, error: false },
      tax_type_3: { value:filteredVendor.tax_type_3, error: false },
      tax_type_4: { value:filteredVendor.tax_type_4, error: false },
      tax_number: { value: filteredVendor.gst_turnover_prev_yr || '', error: false },
      tax_number_2: { value: filteredVendor.tax_number_2 || '', error: false },
      tax_number_3: { value: filteredVendor.gstn || '', error: false },
      tax_number_4: { value: filteredVendor.msme_registration_no || '', error: false },
      recipient_type: { value: filteredVendor.recipient_type || '', error: false },
      recipient_type_2: { value: filteredVendor.recipient_type_2 || '', error: false },
      order_currency: { value: filteredVendor.order_currency || '', error: false },
      vendor_schema: { value:'Z1', error: false },
      tds_details: filteredVendor.tds_details 
    }));
    setRefID(vendor.reference_id)
    setApprovalData(vendor.approval_details)
    setLastApprover(vendor.lastapproval_details)
    setVendorStatus(vendor.approval_status)
    setOpenDialog(true);
    // setOpenApproverDialog(true)
  };

  function formatDate(value) {
    if (!value) return '';
  
    // If value is already in YYYYMMDD format
    if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  
    // If value is in YYYY-MM-DD or similar format
    const dateObj = new Date(value);
  
    // If date is valid, format it
    if (!isNaN(dateObj.getTime())) {
      return dateObj.toISOString().split('T')[0];
    }
  
    // If invalid, don't touch it. Let the user keep typing.
    return value;
  }

  const formatToDDMMYYYY = (rawStr) => {
    if (!/^\d{8}$/.test(rawStr)) return "";
  
    const year = rawStr.slice(0, 4);
    const month = rawStr.slice(4, 6);
    const day = rawStr.slice(6, 8);
  
    return `${day}-${month}-${year}`;
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsEdit(false)
    setSelectedVendor(null);
  };

  const handleEditRequest=()=>{
    setIsEdit(true)
  }

  const handleCloseApprover=()=>{
    setOpenApproverDialog(false)
  }

  
  const handleApproval=()=>{
    console.log("last 2>> ", lastApprover)
    if(approvalData[0].dept==1 || approvalData[0].dept==2 ||  lastApprover[0].user_id==userID){
      setOpenApproverDialog(true)
    }else{
      setOpenComment(true)
    }
  }



  const handleFirstApprove=async(e)=>{
    e.preventDefault();
    setIsActive(true)
    console.log("here is the final form>> ", formValues)
     try{
              const response= await saveVendorPortalForm1(formValues);
              const res= response.data;
              console.log("the response from submit is >> ", res);
              if(res.status){
                console.log("Submitted successfully>> ", res);
                setIsActive(false)
                setOpenComment(true);
              }else{
                console.log("could not submit>> ", res);
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning("Could not submit details",{
                            className: "small-toast"
                          })
                }
                setIsActive(false)
                return;
              }
            }catch(err){
              console.log("Error registering vendor>> ", err)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Error Submitting Details",{
                          className: "small-toast"
                        })
              }
              setIsActive(false)
            }
  }

  const handleSecondApprove=async(e)=>{
    e.preventDefault();
    setIsActive(true)
    console.log("here is the final form>> ", formValues)
    if(formValues.tds_exemption.value==="Yes"){
      if(formValues.tds_nature_of_service.value==="" || formValues.tds_section.value===""){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.warning("Please fill the necessary TDS fields",{
                    className: "small-toast"
                  })
        }
        setIsActive(false)
        return;
      }
    }
     try{
              const response= await saveVendorPortalForm1(formValues);
              const res= response.data;
              console.log("the response from submit is >> ", res);
              if(res.status){
                console.log("Submitted successfully>> ", res);
                setIsActive(false)
                setOpenComment(true);
              }else{
                console.log("could not submit>> ", res);
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning("Could not submit details",{
                            className: "small-toast"
                          })
                }
                setIsActive(false)
                return;
              }
            }catch(err){
              console.log("Error registering vendor>> ", err)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Error Submitting Details",{
                          className: "small-toast"
                        })
              }
              setIsActive(false)
            }
  }

  const filterEmptyValues = (values) => {
    return Object.fromEntries(
      Object.entries(values).filter(([key, obj]) => {
        if (Array.isArray(obj.value)) {
          return obj.value.length > 0; // Remove if empty array
        }
        return obj.value !== ''; // Remove if empty string
      })
    );
  };

  const handleFinalApproval=async(e)=>{
    e.preventDefault();
    setIsActive(true)
    if (!validateTaxFields()){
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.warning("Please fill the necessary tax fields",{
                  className: "small-toast"
                })
      }
      setIsActive(false)
      return;
    }

   


    let filteredValues= filterEmptyValues(formValues)

    const requiredFields = [
      { key: 'bp_grouping', label: 'Bp Grouping' },
      { key: 'search_term_1', label: 'Search Term 1' },
      { key: 'language', label: 'Language' },
      // { key: 'telephone', label: 'Telephone' },
      { key: 'reconciliation_account', label: 'Reconciliation Account' },
      { key: 'company_code', label: 'Company Code' },
      { key: 'payment_terms', label: 'Payment Terms' },
      { key: 'payment_methods', label: 'Payment Methods' },
      { key: 'purchase_organization', label: 'Purchase Organization' },
      { key: 'order_currency', label: 'Order Currency' },
      // Add more if you want to enforce others
    ];
    
    const missingFields = requiredFields.filter(field => {
      const value = filteredValues[field.key]?.value;
      return Array.isArray(value) ? value.length === 0 : !value?.trim();
    });
    
    if (missingFields.length > 0) {
      const fieldNames = missingFields.map(field => field.label).join(', ');
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`Please fill the following required fields: ${fieldNames}`, {
          className: 'small-toast'
        });
      }
      setIsActive(false)
      return;
    }
    console.log("here is the final form>> ", filteredValues)
     try{
              const response= await saveVendorPortalForm1(formValues);
              const res= response.data;
              console.log("the response from submit is >> ", res);
              if(res.status){
                console.log("Submitted successfully>> ", res);
                setIsActive(false)
                setOpenComment(true);
              }else{
                console.log("could not submit>> ", res);
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.warning("Could not submit details",{
                            className: "small-toast"
                          })
                }
                setIsActive(false)
                return;
              }
            }catch(err){
              console.log("Error registering vendor>> ", err)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Error Submitting Details",{
                          className: "small-toast"
                        })
              }
              setIsActive(false)
            }
  }


  const handleReject=()=>{
    setOpenComment2(true);
  }
   const handleRework=()=>{
    setOpenComment3(true);
  }


   const finishApproval=async()=>{
    setIsActive(true)
          const body={
            approvalid: approvalData[0].id,
            vendor_id: approvalData[0].vendor_id,
            user_id: approvalData[0].user_id,
            status: "1",
            comment: comment
          }
          console.log("approval body>> ", body)
          try{
            const response= await approveVendor(body);
            const res= response.data;
            if(res.status){
  
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.success(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
              setOpenDialog(false);
              setOpenComment(false)
              setOpenApproverDialog(false)
              fetchVendors();

            }else{
              console.log("why not approve>> ", res);
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.warning(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
            }
          }catch(err){
            console.log("Error in approving>> ", err)
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(err.message,{
                className:"small-toast"
              })
            }
            setIsActive(false)
          }
  
        }

        const finishReject=async()=>{
          setIsActive(true)
          const body={
            approvalid: approvalData[0].id,
            vendor_id: approvalData[0].vendor_id,
            user_id: approvalData[0].user_id,
            status: "2",
            comment: comment
          }
          try{
            const response= await approveVendor(body);
            const res= response.data;
            if(res.status){
  
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.success(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
              setOpenDialog(false);
              setOpenComment(false)
              fetchAllVendors();
            }else{
              console.log("why not approve>> ", res);
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.warning(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
            }
          }catch(err){
            console.log("Error in approving>> ", err)
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(err.message,{
                className:"small-toast"
              })
            }
            setIsActive(false)
          }
  
        }

        const finishRework=async()=>{
          setIsActive(true)
          const body={
            approvalid: approvalData[0].id,
            vendor_id: approvalData[0].vendor_id,
            user_id: approvalData[0].user_id,
            status: "3",
            comment: comment
          }
          console.log("rework body>> ", body)
          try{
            const response= await approveVendor(body);
            const res= response.data;
            if(res.status){
  
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.success(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
              setOpenDialog(false);
              setOpenComment3(false)
              fetchAllVendors();
            }else{
              console.log("why not approve>> ", res);
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.warning(res.message,{
                  className:"small-toast"
                })
              }
              setIsActive(false)
            }
          }catch(err){
            console.log("Error in approving>> ", err)
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(err.message,{
                className:"small-toast"
              })
            }
            setIsActive(false)
          }
  
        }

  const handleFormChange = (field, value, rowIndex=null) => {
    let updatedValue = value;

    // Check if the field is one of the multi-selects
    if (field === "nature_of_business" || field === "business_category") {
        // For multi-select fields, we need to extract the 'value' from the selected options array
        updatedValue = value.map(option => option.value).filter(v => v);
        setFormValues((prevState) => ({
          ...prevState,
          approved_by: userID
      }));
    }

    if (field === "purchase_organization") {
      setFormValues(prevState => {
          const currentValues = prevState.purchase_organization.value
              ? prevState.purchase_organization.value.split(",")
              : [];

          let newValues = [];

          if (value === "") {
              newValues = []; // if blank, clear everything
          } else {
              const isAlreadySelected = currentValues.includes(value);
              newValues = isAlreadySelected
                  ? currentValues.filter(v => v !== value)
                  : [...currentValues, value];
          }

          const updatedForm = {
              ...prevState,
              purchase_organization: {
                  ...prevState.purchase_organization,
                  value: newValues.join(","),
              },
              reference_id: {
                  ...prevState.reference_id,
                  value: refID || "",
              },
              approved_by: userID
          };

          console.log("Updated formValues 👉", updatedForm);
          return updatedForm;
      });

      setSearchTerm("");
      setDialogOpen(false);
      return;
  }

    if (field === "withholding_tax_type" || field === "withholding_tax_code") {
      const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
      
      setFormValues((prevState) => ({
          ...prevState,
          withholding_tax_type: {
              ...prevState.withholding_tax_type,
              value: taxType || "", // Ensure taxType is set properly
          },
          withholding_tax_code: {
              ...prevState.withholding_tax_code,
              value: taxCode || "", // Ensure taxCode is set properly
          },
          reference_id: {
              ...prevState.reference_id,
              value: refID || "", // Ensure refID is always set
          },
          approved_by: userID
      }));

      setDialogOpen(false);
      setSearchTerm("");
      return; // Exit early since we handled the split case
  }

  if (field === "withholding_tax_type_2") {
    const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
    
    setFormValues((prevState) => ({
        ...prevState,
        withholding_tax_type_2: {
            ...prevState.withholding_tax_type_2,
            value: taxType || "", // Ensure taxType is set properly
        },
        reference_id: {
            ...prevState.reference_id,
            value: refID || "", // Ensure refID is always set
        },
        approved_by: userID
    }));

    setDialogOpen(false);
    setSearchTerm("");
    return; // Exit early since we handled the split case
}

if (field === "withholding_tax_code_2") {
  const [taxType, taxCode] = value.split("#"); // Split the value by hash (#)
  
  setFormValues((prevState) => ({
      ...prevState,
      withholding_tax_code_2: {
          ...prevState.withholding_tax_code_2,
          value: taxCode || "", // Ensure taxType is set properly
      },
      reference_id: {
          ...prevState.reference_id,
          value: refID || "", // Ensure refID is always set
      },
      approved_by: userID
  }));

  setDialogOpen(false);
  setSearchTerm("");
  return; // Exit early since we handled the split case
}

if (rowIndex !== null) {
  setFormValues(prevState => {
    const updatedTdsDetails = [...prevState.tds_details];
    updatedTdsDetails[rowIndex][field] = value;

    return {
      ...prevState,
      tds_details: updatedTdsDetails,
      reference_id: {
        ...prevState.reference_id,
        value: refID || "",
      },
      approved_by: userID,
    };
  });
  setDialogOpen(false);
  setDialogOpen2(false);
  setSearchTerm("");
  return;
}

    // Update the state for the given field
    setFormValues((prevState) => ({
      ...prevState,
      [field]: {
          ...prevState[field],
          value: updatedValue,
      },
      reference_id: {
          ...prevState.reference_id,
          value: refID ||  "", // Ensure refID is always set
      },
      approved_by: userID
  }));
  setSearchTerm("");
  setDialogOpen(false);
  
};

const handleEditVendor=()=>{
  localStorage.setItem("editForm", JSON.stringify(selectedVendor))
  navigate("/vendor/edit-details")
}

const handleApproveEdit=(ven)=>{
  localStorage.setItem("editFormApprover", JSON.stringify(ven))
  navigate("/vendor/approver/edit-details")
}

const handleDropdownClick = (keyName,field) => {
  setKeySelected(keyName);
  setSelectedField(field)
  setDialogOpen(true);      // Open the dialog
};

const handleDropdownClick2 = (keyName,field,index) => {
  setKeySelected(keyName);
  setIndexSelected(index);
  setSelectedField(field)
  setDialogOpen2(true); 
};

 

  return(
    <DashboardLayout>
        <DashboardNavbar/>
        <ToastContainer/>
       <SimpleBackdrop openLoader={isActive}/>

       <div>
      {/* Oval Buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '20px' }}>

      <ButtonGroup className="mb-3" style={{ gap: "10px" }}>
  <Button
    variant={selectedStatus === "all" ? "danger" : "outline-danger"}
    onClick={() => {
      setSelectedStatus("all")
      fetchVendors("all")}}
   className="filterButton"
  >
    All
  </Button>
  <Button
    variant={selectedStatus === "pending" ? "danger" : "outline-danger"}
    onClick={() =>{
      setSelectedStatus("pending")
     fetchVendors("pending")}}
    className="filterButton"
  >
    Pending
  </Button>
  <Button
    variant={selectedStatus === "approved" ? "danger" : "outline-danger"}
    onClick={() => {
      setSelectedStatus("approved")
      fetchVendors("approved")}}
   className="filterButton"
  >
    Approved
  </Button>
  <Button
    variant={selectedStatus === "rejected" ? "danger" : "outline-danger"}
    onClick={() => {
      setSelectedStatus("rejected")
      fetchVendors("rejected")}}
   className="filterButton"
  >
    Rejected
  </Button>

 
</ButtonGroup>
    <input
      type="text"
      placeholder="Search with name or SAP code"
      className="form-control searchMaterialBOX"
      style={{ maxWidth: "250px" , fontSize: "12px"}}
      onChange={handleSearchChange}
    />
      </div>


      {/* Vendor Table */}
      <div style={{ overflowX: "auto" }}>

      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
        <thead>
          <tr style={{ color: "white", backgroundColor: "#3498db" }}>
          {[
  "VENDOR ID",
  "TRADE NAME",
  "TYPE OF FIRM",
  "CITY",
  "STATE",
  "SAP CODE",
  "DOCUMENT STATUS",
  "APPROVAL STATUS",
  "CREATED ON",
  "CREATED BY",
  "ACTION"
]
  .filter((head) => !(head === "APPROVAL STATUS" && selectedStatus === "all"))
  .map((head) => (
    <th
      key={head}
      style={{ whiteSpace: "nowrap", backgroundColor: "#FF2C2C", color: "#FFFFF0" }}
    >
      {head}
    </th>
))}

          </tr>
        </thead>
        <tbody>
          {filteredVendors.map((vendor, index) => (
            <tr style={{ whiteSpace: "nowrap", fontSize: "12px" }} key={index}>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{`#${vendor.reference_id}`}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.trade_name}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.type_of_firm}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.city}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.state}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.sap_code}</td>
              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.approval_status?.toUpperCase()}</td>
              {selectedStatus!=="all" && <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor?.status === 1
  ? "APPROVED"
  : vendor?.status === 2
  ? "REJECTED"
  : "PENDING"
}</td>}
<td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{vendor.info?.created_on}</td>
<td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{`${vendor.info?.name} (${vendor.info?.userid})`}</td>
              <td>
                <SoftButton variant="text" color="primary" onClick={() => handleOpenDialog(vendor)}>
                  <Icon sx={{color:'red'}}>visibility</Icon>
                </SoftButton>
                {vendor?.approval_status === "approved" &&
                <SoftButton variant="text" color="primary" onClick={() => handleApproveEdit(vendor)}>
                  <Icon sx={{color:'red'}}>edit</Icon>
                </SoftButton>
  }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>
    </div>
    <Pagination className="mt-3">
  <Pagination.Prev
    disabled={currentPage === 1}
    onClick={() => handlePageChange(currentPage - 1)}
    style={{
      color: "danger",
      borderRadius: "5px",
    }}
  />

  {/* Always show first page */}
  <Pagination.Item
    active={currentPage === 1}
    onClick={() => handlePageChange(1)}
    style={{
      color: currentPage === 1 ? "#fff" : "danger",
      backgroundColor: currentPage === 1 ? "danger" : "transparent",
      borderRadius: "5px",
    }}
  >
    1
  </Pagination.Item>

  {/* Left dots */}
  {currentPage > 3 && <Pagination.Ellipsis disabled />}

  {/* Middle page numbers */}
  {Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter(
      (page) =>
        page !== 1 &&
        page !== totalPages &&
        Math.abs(currentPage - page) <= 1
    )
    .map((page) => (
      <Pagination.Item
        key={page}
        active={page === currentPage}
        onClick={() => handlePageChange(page)}
        style={{
          color: page === currentPage ? "#fff" : "danger",
          backgroundColor: page === currentPage ? "danger" : "transparent",
          borderRadius: "5px",
        }}
      >
        {page}
      </Pagination.Item>
    ))}

  {/* Right dots */}
  {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}

  {/* Always show last page */}
  {totalPages > 1 && (
    <Pagination.Item
      active={currentPage === totalPages}
      onClick={() => handlePageChange(totalPages)}
      style={{
        color: currentPage === totalPages ? "#fff" : "danger",
        backgroundColor:
          currentPage === totalPages ? "danger" : "transparent",
        borderRadius: "5px",
      }}
    >
      {totalPages}
    </Pagination.Item>
  )}

  <Pagination.Next
    disabled={currentPage === totalPages}
    onClick={() => handlePageChange(currentPage + 1)}
    style={{
      color: "danger",
      borderRadius: "5px",
    }}
  />
</Pagination>


      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullScreen
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div style={{display:'flex', justifyContent:'space-between'}}>


          <span style={{fontSize: "30px" ,color:'red',fontWeight:'bold'}}>Vendor Details</span>
          <SoftTypography color="error" variant="h5">{selectedVendor?.sap_message}</SoftTypography>

          <SoftBox display="flex" justify-content= "space-between" gap={2}>
          {/* {isDept ? (
  approvalStatus === "pending" ? (
    <>
      <SoftButton variant="contained" color="success" onClick={handleApproval}>
        Approve
      </SoftButton>
      <SoftButton variant="contained" color="error" >
        Reject
      </SoftButton>
    </>
  ) : approvalStatus === "department_approved" ? (
    <SoftTypography color="warning">Accounts Approval Pending</SoftTypography>
  ) : approvalStatus === "accounts_approved" ? (
    <SoftTypography color="warning">IT approval pending</SoftTypography>
  ) : approvalStatus === "it_approved" ? (
    <SoftTypography color="warning">Final Approval Pending</SoftTypography>
  ) :approvalStatus === "mdm_approved"?(
    <SoftTypography color="success">Vendor Approved</SoftTypography>
  ): (
    <></>
  )
) : isAcc?(
  approvalStatus === "pending" ? (
    <SoftTypography color="warning">Department Approval Pending</SoftTypography>
  ): approvalStatus === "department_approved" ?(
    <>
    <SoftButton variant="contained" color="success" onClick={handleApproval}>
      Approve
    </SoftButton>
    <SoftButton variant="contained" color="error" >
      Reject
    </SoftButton>
  </>
  ): approvalStatus === "accounts_approved" ?(
    <SoftTypography color="warning">IT Approval Pending</SoftTypography>
  ): approvalStatus === "it_approved" ?(
    <SoftTypography color="warning">Final Approval Pending</SoftTypography>
  ): approvalStatus === "mdm_approved" ?(
    <SoftTypography color="success">Vendor Approved</SoftTypography>
  ):(
    <></>
  )
            ): isIT? (
              approvalStatus === "pending" ? (
                <SoftTypography color="warning">Department Approval Pending</SoftTypography>
              ): approvalStatus === "department_approved" ?(
                <SoftTypography color="warning">Accounts Approval Pending</SoftTypography>
              ): approvalStatus === "accounts_approved" ?(
                <>
                <SoftButton variant="contained" color="success" onClick={handleApproval}>
                  Approve
                </SoftButton>
                <SoftButton variant="contained" color="error" >
                  Reject
                </SoftButton>
              </>
              ): approvalStatus === "it_approved" ?(
                <SoftTypography color="warning">Final Approval Pending</SoftTypography>
              ): approvalStatus === "mdm_approved" ?(
                <SoftTypography color="success">Vendor Approved</SoftTypography>
              ):(
                <></>
              )
            ): isMDM? (
              approvalStatus === "pending" ? (
                <SoftTypography color="warning">Department Approval Pending</SoftTypography>
              ): approvalStatus === "department_approved" ?(
                <SoftTypography color="warning">Accounts Approval Pending</SoftTypography>
              ): approvalStatus === "accounts_approved" ?(
                <SoftTypography color="warning">IT Approval Pending</SoftTypography>
              ): approvalStatus === "it_approved" ?(
                <>
                <SoftButton variant="contained" color="success" onClick={handleApproval}>
                  Approve
                </SoftButton>
                <SoftButton variant="contained" color="error" >
                  Reject
                </SoftButton>
              </>
              ): approvalStatus === "mdm_approved" ?(
                <SoftTypography color="success">Vendor Approved</SoftTypography>
              ):(
                <></>
              )
            ): null} */}





               { approvalAllowed && approvalData[0]?.user_id==userID && vendorStatus=== "pending" ? (
              
              
                  <>
                  
              <SoftButton
                            variant="contained"
                            color="success"
                            onClick={handleApproval}
                          >
                            Approve
                          </SoftButton>
                          <SoftButton
                            variant="contained"
                            color="error"
                            onClick={handleReject}
                          >
                            Reject
                          </SoftButton>

                           <SoftButton
                            variant="contained"
                            color="error"
                            onClick={handleRework}
                          >
                            Re-work
                          </SoftButton>
                  </>  
                    ): (
                      <>
                     {selectedVendor?.approval_status === "approved" ? (
                <SoftTypography color="success" variant="h5">Vendor Approved</SoftTypography>
              ) : selectedVendor?.approval_status === "rejected" ? (
                <SoftTypography color="error" variant="h5">Vendor Rejected</SoftTypography>
              ): selectedVendor?.approval_status === "rework" ? (
                <SoftTypography color="error" variant="h5">Sent for Rework</SoftTypography>
              ) : null}
              
                      </>
                    )
              
                  }
          </SoftBox>
          
            
          </div>
          
        </DialogTitle>
        <DialogContent>
          <Tabs
                                      defaultActiveKey="profile"
                                      id="uncontrolled-tab-example"
                                      className="mb-3"
                                      activeKey={selectedTab}
                                      onSelect={(k)=>{
                                        
                                        setSelectedTab(k)}}
                                    >
                                       <Tab eventKey="details" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Details</span>}>
                                       <SoftBox className="bp">


  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    GENERAL DATA
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>Name</strong></td>
        <td>{selectedVendor?.trade_name}</td>
        <td><strong>Street</strong></td>
        <td>{selectedVendor?.street}</td>
      </tr>
      <tr>
        <td><strong>Type of Firm</strong></td>
        <td>{selectedVendor?.type_of_firm}</td>
        <td><strong>CIN(if applicable)</strong></td>
        <td>{selectedVendor?.cin}</td>
      </tr>
      <tr>
        <td><strong>MCA ROC Status</strong></td>
        <td>{selectedVendor?.mca_roc_status}</td>
        <td><strong>City</strong></td>
        <td>{selectedVendor?.city}</td>
      </tr>
      <tr>
        <td><strong>State</strong></td>
        <td>{selectedVendor?.state}</td>
        <td><strong>Pin Code</strong></td>
        <td>{selectedVendor?.pin_code}</td>
        
      </tr>
      <tr>
        <td><strong>District</strong></td>
        <td>{selectedVendor?.district}</td>
        <td><strong>Website</strong></td>
        <td>{selectedVendor?.website}</td>
      </tr>
      <tr>
        <td><strong>PO Box</strong></td>
        <td>{selectedVendor?.po_box}</td>
        <td><strong>Region</strong></td>
        <td>{selectedVendor?.region}</td>
      </tr>
      <tr>
        <td><strong>Nature of Business</strong></td>
        <td>{selectedVendor?.nature_of_business}</td>
        <td><strong>Business Category</strong></td>
        <td>{selectedVendor?.business_category}</td>
      </tr>
      <tr>
        <td><strong>TDS Exemption/Lower Deduction</strong></td>
        <td>{selectedVendor?.tds_exemption}</td>
        <td><strong>Nature of Service for TDS</strong></td>
        <td>{selectedVendor?.tds_nature_of_service}</td>
      </tr>
      <tr>
        <td><strong>TDS to be Deducted u/s</strong></td>
        <td>{selectedVendor?.tds_section}</td>
        <td><strong>Nature of Service for TDS</strong></td>
        <td>{selectedVendor?.tds_nature_of_service}</td>
      </tr>
      <tr>
        <td><strong>Search Term 1</strong></td>
        <td>{selectedVendor?.search_term_1}</td>
        <td><strong>Search Term 2</strong></td>
        <td>{selectedVendor?.search_term_2}</td>
      </tr>
      <tr>
        <td><strong>BP Grouping</strong></td>
        <td>{kdsdata?.bpgrp?.find(item => item.value ==selectedVendor?.bp_grouping)?.label}</td>
        <td><strong>Language</strong></td>
        <td>{selectedVendor?.language}</td>
      </tr>
     
      <tr>
        <td><strong>SAP Code</strong></td>
        <td>{selectedVendor?.sap_code}</td>
      </tr>
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold'}}>
    CONTACT DETAILS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>Proprieter Name</strong></td>
        <td>{selectedVendor?.proprietor_name}</td>
        <td><strong>Proprieter Email</strong></td>
        <td>{selectedVendor?.proprietor_email}</td>
      </tr>
      <tr>
        <td><strong>Proprietor Mobile</strong></td>
        <td>{selectedVendor?.proprietor_mobile}</td>
        <td><strong>Contact Person Name</strong></td>
        <td>{selectedVendor?.contact_person}</td>
      </tr>
      <tr>
        <td><strong>Contact Person Email</strong></td>
        <td>{selectedVendor?.contact_person_email}</td>
        <td><strong>Contact Person Mobile No</strong></td>
        <td>{selectedVendor?.contact_person_mobile}</td>
      </tr>
      <tr>
        <td><strong>Contact Person Telephone</strong></td>
        <td>{selectedVendor?.contact_telephone}</td>
      </tr>
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    BUSINESS DATA
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>GSTIN</strong></td>
        <td>{selectedVendor?.gstn}</td>
        <td><strong>PAN</strong></td>
        <td>{selectedVendor?.pan}</td>
      </tr>
      <tr>
        <td><strong>TAN</strong></td>
        <td>{selectedVendor?.tan}</td>
        <td><strong>Status of filing ITR of last 2 yrs</strong></td>
        <td>{selectedVendor?.itr_filing_status}</td>
      </tr>
      <tr>
        <td><strong>PAN linked with Aadhaar</strong></td>
        <td>{selectedVendor?.pan_linked_aadhaar}</td>
        <td><strong>GST Turnover of Prev Yr</strong></td>
        <td>{selectedVendor?.gst_turnover_prev_yr}</td>
      </tr>
      <tr>
        <td><strong>MSME Registration Status</strong></td>
        <td>{selectedVendor?.msme_registration_status}</td>
        <td><strong>MSME Registration No</strong></td>
        <td>{selectedVendor?.msme_registration_no}</td>
      </tr>
      <tr>
        <td><strong>MSME Type</strong></td>
        <td>{selectedVendor?.msme_type}</td>
        <td><strong>FSSAI Registration Status</strong></td>
        <td>{selectedVendor?.fssai_registration_status}</td>
      </tr>
      <tr>
        <td><strong>FSSAI Registration No</strong></td>
        <td>{selectedVendor?.fssai_regn_no}</td>
        <td><strong>FSSAI Valid Till</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.fssai_valid_till)}</td>
      </tr>
      
      <tr>
        <td><strong>CST No</strong></td>
        <td>{selectedVendor?.cst_no}</td>
        <td><strong>LST No</strong></td>
        <td>{selectedVendor?.lst_no}</td>
      </tr>

      <tr>
        <td><strong>Contact Allowance</strong></td>
        <td>{selectedVendor?.contact_allowance}</td>
        <td><strong>C/O Name</strong></td>
        <td>{selectedVendor?.co_name}</td>
      </tr>

      <tr>
        <td><strong>Reconciliation Account</strong></td>
        <td>{kdsdata?.reconacc?.find(item => item.value ==selectedVendor?.reconciliation_account)?.label}</td>
        <td><strong>Sort Key</strong></td>
        <td>{kdsdata.sortkey?.find(item => item.value ==selectedVendor?.sort_key)?.label}</td>
      </tr>

      <tr>
        <td><strong>Payment Terms</strong></td>
        <td>{kdsdata?.payterms?.find(item => item.value ==selectedVendor?.payment_terms)?.label}</td>
        <td><strong>Payment Methods</strong></td>
        <td>{kdsdata?.paymthd?.find(item => item.value ==selectedVendor?.payment_methods)?.label}</td>
      </tr>

      <tr>
        <td><strong>Withholding Tax Type</strong></td>
        <td>{selectedVendor?.withholding_tax_type}</td>
        <td><strong>Withholding Tax Code</strong></td>
        <td>{selectedVendor?.withholding_tax_code}</td>
      </tr>

      <tr>
        <td><strong>Withholding Subject</strong></td>
        <td>{selectedVendor?.withholding_subject}</td>
        <td><strong>Recipient Type</strong></td>
        <td>{selectedVendor?.recipient_type}</td>
      </tr>

      <tr>
        <td><strong>Tax Type 1</strong></td>
        <td>{selectedVendor?.tax_type_1}</td>
        <td><strong>Tax Number 1</strong></td>
        <td>{selectedVendor?.tax_number_1}</td>
      </tr>

      <tr>
        <td><strong>Tax Type 2</strong></td>
        <td>{selectedVendor?.tax_type_2}</td>
        <td><strong>Tax Number 2</strong></td>
        <td>{selectedVendor?.tax_number_2}</td>
      </tr>

      <tr>
        <td><strong>Tax Type 3</strong></td>
        <td>{selectedVendor?.tax_type_3}</td>
        <td><strong>Tax Number 3</strong></td>
        <td>{selectedVendor?.tax_number_3}</td>
      </tr>

      <tr>
        <td><strong>Tax Type 4</strong></td>
        <td>{selectedVendor?.tax_type_4}</td>
        <td><strong>Tax Number 4</strong></td>
        <td>{selectedVendor?.tax_number_4}</td>
      </tr>

      <tr>
        <td><strong>GR Based Invoice Verification</strong></td>
        <td>{selectedVendor?.gr_based_invoice_verification}</td>
        <td><strong>Service Based Invoice Verification</strong></td>
        <td>{selectedVendor?.service_based_invoice_verification}</td>
      </tr>

      <tr>
        <td><strong>Purchase Organization</strong></td>
        <td>{kdsdata?.porg?.find(item => item.value ==selectedVendor?.purchase_organization)?.label}</td>
        <td><strong>Order Currency</strong></td>
        <td>{kdsdata?.ordrcurr?.find(item => item.value ==selectedVendor?.order_currency)?.label}</td>
      </tr>

      <tr>
        <td><strong>Scheme Group Supplier</strong></td>
        <td>{selectedVendor?.vendor_schema}</td>
      </tr>

      <tr>
        <td><strong>e-Invoice Applicable</strong></td>
        <td>{selectedVendor?.e_invoice_applicable}</td>
        <td><strong>Bank Name</strong></td>
        <td>{selectedVendor?.bank_name}</td>
      </tr>

      <tr>
        <td><strong>IFSC Code</strong></td>
        <td>{selectedVendor?.ifsc_code}</td>
        <td><strong>Bank Account No</strong></td>
        <td>{selectedVendor?.bank_account_number}</td>
      </tr>

      <tr>
        <td><strong>Cheque to be Issued in name of</strong></td>
        <td>{selectedVendor?.cheque_issued_name}</td>
        <td><strong>Bank Key</strong></td>
        <td>{selectedVendor?.bank_key}</td>
      </tr>
    </tbody>
  </Table>
  </>

<>
<SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    TDS DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
      <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Section Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Number</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Rate</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt From</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt To</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Reason</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exem Threshold</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Currency</th>
        </tr>
      </thead>
      <tbody>
        {selectedVendor?.
tds_details
?.map((item, index)=> (
          <tr key={index} className="border">
            <td className="border p-2" id={`section_code_${index}`}>{item.section_code}</td>
            <td className="border p-2" id={`exemption_number_${index}`}>{item.exemption_number}</td>
            <td className="border p-2" id={`exemption_rate_${index}`}>{item.exemption_rate}</td>
            <td className="border p-2" id={`exemption_from_${index}`}>{formatToDDMMYYYY(item.exemption_from)}</td>
            <td className="border p-2" id={`exemption_to_${index}`}>{formatToDDMMYYYY(item.exemption_to)}</td>
            <td className="border p-2" id={`exemption_reason_${index}`}>{item.exemption_reason}</td>
            <td className="border p-2" id={`withholding_tax_type_3_${index}`}>{item.withholding_tax_type_3}</td>
            <td className="border p-2" id={`withholding_tax_code_3_${index}`}>{item.withholding_tax_code_3}</td>
            <td className="border p-2" id={`exemp_threshold_${index}`}>{item.exemp_threshold}</td>
            <td className="border p-2" id={`currency_${index}`}>{item.currency}</td>
          </tr>
        ))}
      </tbody>
    </Table>
</>

 

  

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    UPLOADED DOCUMENTS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>GSTIN Document</strong></td>
        <td>{selectedVendor?.gstn_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.gstn_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>PAN Document</strong></td>
        <td>{selectedVendor?.pan_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.pan_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>

      <tr>
        <td><strong>MSME Document</strong></td>
        <td>{selectedVendor?.msme_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.msme_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>FSSAI Document</strong></td>
        <td>{selectedVendor?.fssai_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.fssai_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>

      <tr>
        <td><strong>TDS Document</strong></td>
        <td>{selectedVendor?.tds_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.tds_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>Latest CO Status Document</strong></td>
        <td>{selectedVendor?.latest_co_status_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.latest_co_status_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
   
      </tr>
      <tr>
        <td><strong>Cancel Cheque Document</strong></td>
        <td>{selectedVendor?.cancel_cheque_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.cancel_cheque_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>
     
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    APPROVER DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER NAME</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER EMAIL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVAL STATUS</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVED ON</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>COMMENT</th>
      </tr>
    </thead>
    <tbody>
      {allApproveDetails?.map((company) => (
        <tr key={company.id} className="border">
          <td className="border p-2">{company.approver_name}</td>
          <td className="border p-2">{company.email}</td>
          <td className="border p-2">
            {company.status}
          </td>
          <td className="border p-2">{company.approved_on}</td>
          <td className="border p-2">{company.comment}</td>
        </tr>
      ))}
    </tbody>
  </Table>
  </>



            </SoftBox>
                                       </Tab>
                                       <Tab eventKey="log" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Log</span>}>
                                       <>
   <SoftTypography
     variant="h5"
     color="error"
     gutterBottom
     style={{ marginTop: 20, fontWeight: 'bold' }}
   >
     VENDOR AUDIT LOG
   </SoftTypography>
 

   



   {allAuditLogs?.length > 0 &&
  allAuditLogs.map((entry, i) => {
    const isUpdate = entry.action === 'UPDATE';
    const hasChangeData = isUpdate && Object.keys(entry.changedata || {}).length > 0;

    if (isUpdate && hasChangeData) {
      return (
        <div key={i} style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)'
            }}
          />

          {/* Timestamp */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>

          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 15, overflow: 'hidden' }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                {/* <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div> */}
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>

            {Object.entries(entry.changedata).map(([field, value], idx) => (
              <div key={idx} style={{ marginBottom: 10 }}>
                <div><strong>Field:</strong> {fieldDisplayNames[field] || '-'}</div>
                {field === 'tds_details' && Array.isArray(value?.new) ? (
                  <>
                   <div>
                    <strong>Changed From:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Section Code</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Exemption No</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Rate</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>From</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>To</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value?.old?.map((item, index) => (
                          <tr key={index}>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.section_code}</s></td>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.exemption_number}</s></td>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.exemption_rate}</s></td>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.exemption_from}</s></td>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.exemption_to}</s></td>
                          <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.exemption_reason}</s></td>
                        </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <strong>To:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Section Code</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Exemption No</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Rate</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>From</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>To</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.new.map((item, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.section_code}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.exemption_number}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.exemption_rate}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.exemption_from}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.exemption_to}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.exemption_reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  </>
                ) : (
                  <>
                  <div><strong>Changed From:</strong> <del>{value?.old || '-'}</del> {' '} <strong>To:</strong> {value?.new || '-'}</div>
                  </>
                )}
              </div>
            ))}

            <div><strong>Changed By:</strong> {entry.userdetails?.[0]?.name || '-'}</div>
          </div>
        </div>
      );
    } else if(entry.action==="CREATE") {
      return (
        <div key={i} style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)'
            }}
          />
          {/* Timestamp */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>

          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 15, overflow: 'hidden' }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div>
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>

            <div><strong>Vendor Created</strong> </div>
          </div>
        </div>
      );
    }else{
      return;
    }
  })}


 

 

 
 </>
                                       </Tab>
                                                                  
                                    </Tabs>
        
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="flex-end" mt={2} spacing={3}>
              <Grid item>
                <SoftButton onClick={handleCloseDialog} variant="contained" color="error">
                  Close
                </SoftButton>

              </Grid>
              <Grid item>
              {editAllowed && 
              
                <SoftButton onClick={handleEditVendor} variant="contained" color="error">
                  Edit
                </SoftButton>
              }
              </Grid>
            </Grid>
        </DialogActions>
        
      </Dialog>

      <Dialog
        open={openApproverDialog}
        onClose={handleCloseApprover}
        fullScreen
        maxWidth="md"
      >
        <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>
        <div style={{display:'flex', justifyContent:'space-between'}}>
        <span style={{fontSize: "25px"}}>Approval Fields</span>
        <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseApprover} // You can define this function to close the dialog
            aria-label="close"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        </DialogTitle>
        <DialogContent>
          {approvalData[0]?.dept==1 &&  (approvalData[0]?.user_id== userID)?(
            <form onSubmit={handleFirstApprove}>
              
                
                  
                    <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12} sm={4}>
   
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
         Nature of Business*
       </SoftTypography>
     </SoftBox>

     
     <Select
isMulti
menuPlacement="auto"
menuPortalTarget={document.body} // Ensures it renders outside the dialog
menuPosition="fixed" // Prevents it from being cut off
name="nature_of_business"
id="nature_of_business"
value={
  formValues.nature_of_business.value.length > 0
    ? formValues.nature_of_business.value.map((val) => ({ value: val, label: val }))
    : null
}

  onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
  options={[
    { value: "Capital Goods", label: "Capital Goods" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Trading", label: "Trading" },
    { value: "Exporter", label: "Exporter" },
    { value: "Service", label: "Service" },
    { value: "CSR", label: "CSR" },
    { value: "OTPY", label: "OTPY" },
  ]}
  styles={{
    control: (provided) => ({
      ...provided,
      minHeight: "34px",
      fontSize: "9px",
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: "10px",
      padding: "2px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, 
      position: "absolute",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
  }}
/>

   
 </Grid>
 <Grid item xs={12} sm={4}>
   
     <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
       <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
         Business Category*
       </SoftTypography>
     </SoftBox>
     <Select
       isMulti
       name="business_category"
       id="business_category"
       menuPlacement="auto"
       menuPortalTarget={document.body} // Ensures it renders outside the dialog
       menuPosition="fixed" // Prevents it from being cut off
      //  value={[
      //   {value: formValues.business_category.value,label: formValues.business_category.value}
      // ]}

      value={
        formValues.business_category.value.length > 0
          ? formValues.business_category.value.map((val) => ({ value: val, label: val }))
          : null
      }
      
       error={formValues.business_category.error}
       // value={formvalues.business}
       onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
       options={[
         { value: "Raw Mat", label: "Raw Mat" },
         { value: "Packaging Mat", label: "Packaging Mat" },
         { value: "Engg Store", label: "Engg Store" },
         { value: "Fuel", label: "Fuel" },
         { value: "Transporter", label: "Transporter" },
         { value: "Contractor", label: "Contractor" },
         { value: "Oth Services", label: "Oth Services" },
         { value: "Capital", label: "Capital" },
         { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
       ]}
       styles={{
        control: (provided) => ({
          ...provided,
          minHeight: "34px",
          fontSize: "9px",
        }),
        multiValue: (provided) => ({
          ...provided,
          fontSize: "10px",
          padding: "2px",
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: "12px",
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: "4px",
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999, 
          position: "absolute",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
      }}
     />
   
 </Grid>
                    </Grid>
                 
                    <div style={{ marginTop: "10px" }}>
  <SoftButton type="submit" color="success" variant="contained">
    Submit
  </SoftButton>
</div>
              
            </form>
          ): approvalData[0]?.dept === 2  && approvalData[0]?.user_id !== lastApprover[0]?.user_id
          ?(
            <form onSubmit={handleSecondApprove}>
             
                
             
                <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS Exemption/Lower Deduction
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                            name="tds_ememption"
                            id="tds_exemption"
                           //  error={formValues.tds_exemption.error}
                           value={[
                             {value: formValues.tds_exemption.value,label: formValues.tds_exemption.value}
                           ]}
                             onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Nature of Service for TDS
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_nature"
                             id="td_nature"
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.tds_nature_of_service.value}
                             onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS to be Deducted u/s
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_section"
                             id="tds_section"
                            //  error={formValues.tds_section.error}
                             value={formValues.tds_section.value}
                             onChange={(e) => handleFormChange('tds_section', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                </Grid>
                
                <SoftButton type="submit" color="success" variant="contained" mt={1}>Submit</SoftButton>
             
            </form>
          ): lastApprover[0]?.user_id==userID || lastApprover[0]?.user_id== approvalData[0]?.user_id?(
            <form onSubmit={handleFinalApproval}>
              <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                <SoftBox py={2} style={{ overflowX: "auto" }}>
                <Grid container alignItems="center" spacing={0.5}>
                <Grid item xs={12}>
                <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Basic Data</SoftTypography>
  </Grid>
                <Grid item xs={12} sm={4}>
   
   <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
     <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
       Nature of Business
     </SoftTypography>
   </SoftBox>

   
   <Select
isMulti
menuPlacement="auto"
menuPortalTarget={document.body} // Ensures it renders outside the dialog
menuPosition="fixed" // Prevents it from being cut off
name="nature_of_business"
id="nature_of_business"
value={
  formValues.nature_of_business.value.length > 0
    ? formValues.nature_of_business.value.map((val) => ({ value: val, label: val }))
    : null
}
onChange={(selectedOptions) => handleFormChange("nature_of_business", selectedOptions)}
options={[
  { value: "Capital Goods", label: "Capital Goods" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Trading", label: "Trading" },
  { value: "Exporter", label: "Exporter" },
  { value: "Service", label: "Service" },
  { value: "CSR", label: "CSR" },
  { value: "OTPY", label: "OTPY" },
]}
styles={{
  control: (provided) => ({
    ...provided,
    minHeight: "34px",
    fontSize: "9px",
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: "10px",
    padding: "2px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "12px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, 
    position: "absolute",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
}}
/>

 
</Grid>
<Grid item xs={12} sm={4}>
 
   <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
     <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
       Business Category
     </SoftTypography>
   </SoftBox>
   <Select
    isMulti
    name="business_category"
    id="business_category"
    menuPlacement="auto"
    menuPortalTarget={document.body} // Ensures it renders outside the dialog
    menuPosition="fixed" // Prevents it from being cut off
  //   value={[
  //    {value: formValues.business_category.value,label: formValues.business_category.value}
  //  ]}
  value={
    formValues.business_category.value.length > 0
      ? formValues.business_category.value.map((val) => ({ value: val, label: val }))
      : null
  }
    error={formValues.business_category.error}
     // value={formvalues.business}
     onChange={(selectedOptions) => handleFormChange("business_category", selectedOptions)}
     options={[
       { value: "Raw Mat", label: "Raw Mat" },
       { value: "Packaging Mat", label: "Packaging Mat" },
       { value: "Engg Store", label: "Engg Store" },
       { value: "Fuel", label: "Fuel" },
       { value: "Transporter", label: "Transporter" },
       { value: "Contractor", label: "Contractor" },
       { value: "Oth Services", label: "Oth Services" },
       { value: "Capital", label: "Capital" },
       { value: "Adv & Sales Prom", label: "Adv & Sales Prom" },
     ]}
     styles={{
      control: (provided) => ({
        ...provided,
        minHeight: "34px",
        fontSize: "9px",
      }),
      multiValue: (provided) => ({
        ...provided,
        fontSize: "10px",
        padding: "2px",
      }),
      placeholder: (provided) => ({
        ...provided,
        fontSize: "12px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "4px",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999, 
        position: "absolute",
      }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is always visible
    }}
   />
 
</Grid>

<Grid item xs={12} sm={4}>
                        
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS Exemption/Lower Deduction
                             </SoftTypography>
                           </SoftBox>
                           <SoftSelect
                             name="tds_ememption"
                             id="tds_exemption"
                            //  error={formValues.tds_exemption.error}
                            value={[
                              {value: formValues.tds_exemption.value,label: formValues.tds_exemption.value}
                            ]}
                             onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             options={[
                               { value: "Yes", label: "Yes" },
                               { value: "No", label: "No" },
                               
                             ]}
                           />
                        
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Nature of Service for TDS
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_nature"
                             id="td_nature"
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.tds_nature_of_service.value}
                             onChange={(e) => handleFormChange('tds_nature_of_service', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              TDS to be Deducted u/s
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="tds_section"
                             id="tds_section"
                            //  error={formValues.tds_section.error}
                             value={formValues.tds_section.value}
                             onChange={(e) => handleFormChange('tds_section', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Search Term 1
                             </SoftTypography>
                           </SoftBox>
                         
                            
                           <SoftInput
                             name="search_term_1"
                             id="search_term_1"
                             value={ formValues.search_term_1.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('search_term_1', e.target.value)}
                             
                           />
                           
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Search Term 2
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="search_term_2"
                             id="search_term_2"
                             value={ formValues.search_term_2.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('search_term_2', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              BP Grouping*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('bpgrp','bp_grouping')}>
                            
                           <SoftInput
                             name="bp_grouping"
                             id="bp_grouping"
                             value={formValues.bp_grouping.value}
                             readOnly
                             style={{cursor:'pointer'}}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Language
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="language"
                             id="language"
                             disabled
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.language.value}
                             onChange={(e) => handleFormChange('language', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Telephone
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="telephone"
                             id="telephone"
                            //  error={formValues.tds_section.error}
                             value={ formValues.telephone.value}
                             onChange={(e) => handleFormChange('telephone', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              District
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="district"
                             id="district"
                             value={formValues.district.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('district', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Po Box
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="po_box"
                             id="po_box"
                             value={ formValues.po_box.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('po_box', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Region
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('region','region')}>
                            
                           <SoftInput
                             name="region"
                             id="region"
                             readOnly
                             value={ formValues.region.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12}>
                       <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Company Code Data</SoftTypography>
  </Grid>

  <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Company Code*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('compcode','company_code')}>
                            
                           <SoftInput
                             name="region"
                             id="region"
                             readOnly
                             value={ formValues.company_code.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              CST No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="cst_no"
                             id="cst_no"
                            //  error={formValues.tds_section.error}
                             value={formValues.cst_no.value}
                             onChange={(e) => handleFormChange('cst_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              LST No.
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="lst_no"
                             id="lst_no"
                            //  error={formValues.tds_section.error}
                             value={formValues.lst_no.value}
                             onChange={(e) => handleFormChange('lst_no', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Contact Allowance
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <Checkbox name="contact_allowance"
                             id="contact_allowance"
                                                  checked={formValues.contact_allowance.value=='1'}
                                                  onChange={(e) => handleFormChange('contact_allowance', e.target.checked? '1':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                    
                       
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              C/O Name
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="co_name"
                             id="co_name"
                             value={formValues.co_name.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('co_name', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Reconciliation Account*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('reconacc', 'reconciliation_account')}>
                            
                            <SoftInput
                              name="recon_account"
                              id="recon_account"
                              readOnly
                              value={formValues.reconciliation_account.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Sort Key.
                             </SoftTypography>
                           </SoftBox>
                           <div >
                            
                            <SoftInput
                              name="sort_key"
                              id="sort_key"
                              disabled
                              value={formValues.sort_key.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Payment Terms*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('payterms','payment_terms')}>
                            
                            <SoftInput
                              name="payment_terms"
                              id="payment_terms"
                              readOnly
                              value={formValues.payment_terms.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Payment Methods*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('paymthd', 'payment_methods')}>
                            
                           <SoftInput
                             name="payment_methods"
                             id="payment_methods"
                             readOnly
                             value={formValues.payment_methods.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Bank Key.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('bankkey', 'bank_key')}>
                            
                            <SoftInput
                              name="bank_key"
                              id="bank_key"
                              readOnly
                              value={formValues.bank_key.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Account Holder Name
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="account_holder_name"
                             id="account_holder_name"
                             value={ formValues.account_holder_name.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('account_holder_name', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              ABC Indicator
                             </SoftTypography>
                           </SoftBox>

                           <SoftSelect
                                                        name="abc_indicator"
                                                        id="abc_indicator"
                                                       //  error={formValues.msme_type.error}
                                                        value={[{value: formValues.abc_indicator.value, label: formValues.abc_indicator.value}]}
                                                        onChange={(e) => handleFormChange('abc_indicator', e.value)}
                                                        options={[
                                                          { value: "A", label: "A" },
                                                          { value: "B", label: "B" },
                                                          { value: "C", label: "C" },
                                                          { value: "D", label: "D" },
                                                          { value: "E", label: "E" },
                                                          { value: "F", label: "F" },
                                                        ]}
                                                      />
                          
                         </SoftBox>
                       </Grid>

                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Tax Type.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                           <SoftInput
                             name="witholding_tax"
                             id="witholding_tax"
                             value={formValues.withholding_tax_type.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Tax Code.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('witall', 'withholding_tax_code')}></div>
                           <SoftInput
                           type="text"
                             name="withholding_tax_code"
                             id="withholding_tax_code"
                            
                            //  error={formValues.tds_section.error}
                             value={formValues.withholding_tax_code.value}
                            //  onChange={(e) => handleFormChange('withholding_tax_code', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Withholding Subject
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="withholding_subject"
                             id="withholding_subject"
                                                  checked={formValues.withholding_subject.value=='X'}
                                                  onChange={(e) => handleFormChange('withholding_subject', e.target.checked? 'X':'')}
                                                />
                          
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Recipient Type.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type')}>
                            
                           <SoftInput
                             name="recipient_type"
                             id="recipient_type"
                             value={formValues.recipient_type.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid> */}

                       <Table   bordered hover size="sm" style={{ fontSize: 12 , padding:3}}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Subject</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Recipient Type</th>
                      </tr>
                       </thead>
                       <tbody>
                       <tr className="border">
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                            <SoftInput
                              name="witholding_tax"
                              id="witholding_tax"
                              readOnly
                              value={formValues.withholding_tax_type.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type')}>
                            
                            <SoftInput
                              name="witholding_code"
                              id="witholding_code"
                              readOnly
                              value={formValues.withholding_tax_code.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2 bg-white">
                       <div className="flex items-center justify-center">
    <Checkbox
      name="withholding_subject"
      id="withholding_subject"
      checked={formValues.withholding_subject.value == 'X'}
      onChange={(e) => handleFormChange('withholding_subject', e.target.checked ? 'X' : '')}
       sx={{ color: "#01040a" , backgroundColor: "#fff"}}
    />
  </div>
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type')}>
                            
                            <SoftInput
                              name="recipient_type"
                              id="recipient_type"
                              value={formValues.recipient_type.value}
                              readOnly
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       </tr>
                       <tr className="border">
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_type_2')}>
                            
                            <SoftInput
                              name="witholding_tax"
                              id="witholding_tax"
                              readOnly
                              value={formValues.withholding_tax_type_2.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('witall', 'withholding_tax_code_2')}>
                            
                            <SoftInput
                              name="witholding_code"
                              id="witholding_code"
                              readOnly
                              value={formValues.withholding_tax_code_2.value}
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       <td className="border p-2 bg-white">
  <div className="flex items-center justify-center">
    <Checkbox
      name="withholding_subject"
      id="withholding_subject"
      checked={formValues.withholding_subject_2.value == 'X'}
      onChange={(e) => handleFormChange('withholding_subject_2', e.target.checked ? 'X' : '')}
      sx={{ color: "#01040a", backgroundColor: "#fff" }}
      className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
    />
  </div>
</td>

                       <td className="border p-2">
                        { <div onClick={() => handleDropdownClick('recpttyp', 'recipient_type_2')}>
                            
                            <SoftInput
                              name="recipient_type"
                              id="recipient_type"
                              value={formValues.recipient_type_2.value}
                              readOnly
                             //  error={formValues.tds_exemption.error}
                              // value={formValues.tds_exemption.value}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                              
                            />
                            </div>}
                       </td>
                       </tr>
                       </tbody>
                       </Table>

                        <div style={{overflowX: 'auto'}}>

                       <Table   bordered hover size="sm" style={{ fontSize: 12 , padding:3 }}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Section Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Number</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Rate</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt From</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exempt To</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exemption Reason</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Withholding Tax Code</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Exem Threshold</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Currency</th>
                      </tr>
                       </thead>
                       <tbody>
  {formValues.tds_details.map((item, index) => (
    <tr key={index} className="border">
      {/* Section Code */}
      <td className="border p-2">
        <div className="flex justify-center">
          <SoftSelect
            name="section_code"
            id={`section_code_${index}`}
            value={[{ value: item.section_code, label: item.section_code }]}
            options={[{ value: "GR01", label: "GR01" }]}
            menuPlacement="auto"
            onChange={(e) => handleFormChange("section_code", e.value, index)}
          />
        </div>
      </td>

      {/* Exemption Number */}
      <td className="border p-2">
        <SoftInput
          type="text"
          name="exemption_number"
          id={`exemption_number_${index}`}
          className="w-full"
          value={item.exemption_number}
          onChange={(e) =>
            handleFormChange("exemption_number", e.target.value, index)
          }
        />
      </td>

      {/* Exemption Rate */}
      <td className="border p-2">
        <SoftInput
          type="number"
          name="exemption_rate"
          id={`exemption_rate_${index}`}
          className="w-full"
          value={item.exemption_rate}
          onChange={(e) =>
            handleFormChange("exemption_rate", e.target.value, index)
          }
        />
      </td>

      {/* Exemption From Date */}
      <td className="border p-2">
  <div className="flex items-center justify-center min-w-[10rem]">
    <SoftInput
      className="w-full"
      type="date"
      name="exemption_from"
      id={`exemption_from_${index}`}
      value={formatDate(item.exemption_from)}
      onChange={(e) => {
        const raw = e.target.value;
        const [year, month, day] = raw.split("-");
        const formatted = `${year}${month}${day}`;
        handleFormChange("exemption_from", formatted, index);
      }}
    />
  </div>
</td>


      {/* Exemption To Date */}
      <td className="border p-2">
  <div className="flex items-center justify-center min-w-[10rem]">
    <SoftInput
      className="w-full"
      type="date"
      name="exemption_to"
      id={`exemption_to_${index}`}
      value={formatDate(item.exemption_to)}
      onChange={(e) => {
        const raw = e.target.value;
        const [year, month, day] = raw.split("-");
        const formatted = `${year}${month}${day}`;
        handleFormChange("exemption_to", formatted, index);
      }}
    />
  </div>
</td>


      {/* Exemption Reason */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdsrsn", "exemption_reason", index)
          }
        >
          <SoftInput
            readOnly
            name="exemption_reason"
            id={`exemption_reason_${index}`}
            value={item.exemption_reason}
            className="w-full"
          />
        </div>
      </td>

      {/* Withholding Tax Type */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdstype", "withholding_tax_type_3", index)
          }
        >
          <SoftInput
            readOnly
            name="withholding_tax_type_3"
            id={`withholding_tax_type_3_${index}`}
            value={item.withholding_tax_type_3}
            className="w-full"
          />
        </div>
      </td>

      {/* Withholding Tax Code */}
      <td className="border p-2">
        <div
          onClick={() =>
            handleDropdownClick2("tdscode", "withholding_tax_code_3", index)
          }
        >
          <SoftInput
            readOnly
            name="withholding_tax_code_3"
            id={`withholding_tax_code_3_${index}`}
            value={item.withholding_tax_code_3}
            className="w-full"
          />
        </div>
      </td>

      {/* Threshold */}
      <td className="border p-2">
        <SoftInput
          type="number"
          name="exemp_threshold"
          id={`exemp_threshold_${index}`}
          className="w-full"
          value={item.exemp_threshold}
          onChange={(e) =>
            handleFormChange("exemp_threshold", e.target.value, index)
          }
        />
      </td>

      {/* Currency */}
      <td className="border p-2">
        <SoftInput
          type="text"
          name="currency"
          id={`currency_${index}`}
          className="w-full"
          value={item.currency}
          onChange={(e) =>
            handleFormChange("currency", e.target.value, index)
          }
        />
      </td>

      {/* Remove Button */}
      <td className="border p-2 text-center align-middle">
        {index > 0 && (
          <SoftButton onClick={() => handleRemoveRow(index)} color="error">
            ❌
          </SoftButton>
        )}
      </td>
    </tr>
  ))}
</tbody>

{/* Add Row Button in Footer */}
<tfoot>
  <tr>
    <td colSpan={11} className="p-3 text-right">
      <SoftButton onClick={handleAddRow} color="success">
        ➕ Add Row
      </SoftButton>
    </td>
  </tr>
</tfoot>


                       </Table>
                        </div>
                       
                       <Table striped  bordered hover size="sm" style={{ fontSize: 12 }}>
                       <thead>
                       <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Tax Type</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >Tax Number</th>
                      </tr>
                       </thead>
                       <tbody>
                       <tr className="border">
                            <td className="border p-2">{
                          <Grid item xs={12} sm={4}>
                          <SoftBox mb={3} id="name3">
                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SoftTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                               Tax Type 1
                              </SoftTypography>
                            </SoftBox>
                            <div onClick={() => handleDropdownClick('taxtype', 'tax_type')}>
                            {/* <TextField
   name="tax_type"
   id="tax_type"
   disabled
   // onChange={(e) => handleFormChange('tax_type', e.target.value)}
   InputProps={{
     startAdornment: <InputAdornment position="start">
     <Typography sx={{ fontSize: '15px' }}>IN1</Typography>
   </InputAdornment>,
   }}
   variant="outlined"
 /> */}
                            <SoftInput
                              name="tax_type"
                              id="tax_type"
                              readOnly
                              value={formValues.tax_type.value}
                              error={formValues.tax_type.error}
                             //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                            
                            />
                            </div>
                          </SoftBox>
                        </Grid>
                          }</td>
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 1
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number"
                             id="tax_number"
                             value={ formValues.tax_number.value}
                             error={formValues.tax_number.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{ <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 2
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_2')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  // value={selectedVendor?.gst_turnover_prev_yr
  // }
  disabled
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: <InputAdornment position="start">
    <Typography sx={{ fontSize: '15px' }}>IN2</Typography>
  </InputAdornment>,
  }}
  variant="outlined"
/> */}
  <SoftInput
                             name="tax_type_2"
                             id="tax_type_2"
                             readOnly
                             value={formValues.tax_type_2.value}
                             error={formValues.tax_type_2.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{ <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 2
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_2"
                             id="tax_number_2"
                             value={ formValues.tax_number_2.value}
                             error={formValues.tax_number_2.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_2', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 3
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_3')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: <InputAdornment position="start">
    <Typography sx={{ fontSize: '15px' }}>IN3</Typography>
  </InputAdornment>,
  }}
  variant="outlined"
/> */}

<SoftInput
                             name="tax_type_3"
                             id="tax_type_3"
                             readOnly
                             value={formValues.tax_type_3.value}
                             error={formValues.tax_type_3.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 3
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_3"
                             id="tax_number_3"
                             value={ formValues.tax_number_3.value}
                             error={formValues.tax_number_3.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_3', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>}</td>
                          </tr>
                          <tr className="border">
                            <td className="border p-2">{<Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 4
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_4')}>
                            
                           {/* <TextField
  name="tax_type"
  id="tax_type"
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontSize: '15px' }}>IN4</Typography>
      </InputAdornment>
    ),
  }}
  variant="outlined"
/> */}

<SoftInput
                             name="tax_type_4"
                             id="tax_type_4"
                             readOnly
                             value={formValues.tax_type_4.value}
                             error={formValues.tax_type_4.error}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                           
                           />
                           </div>
                         </SoftBox>
                       </Grid>}</td>
                       <td className="border p-2">{  <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 4
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_4"
                             id="tax_number_4"
                             value={ formValues.tax_number_4.value}
                             error={formValues.tax_number_4.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_4', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid>
}</td>
                          </tr>
                       </tbody>
                       </Table>
                       
                       <Grid item xs={12}>
                       <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>Purchasing Data</SoftTypography>
  </Grid>
                      
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              GR based invoice verification
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="gr_based_invoice_verification"
                             id="gr_based_invoice_verification"
                                                  checked={formValues.gr_based_invoice_verification.value=='X'}
                                                  onChange={(e) => handleFormChange('gr_based_invoice_verification', e.target.checked? 'X':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Service based invoice verification
                             </SoftTypography>
                           </SoftBox>
                       
                            <Checkbox name="service_based_invoice_verification"
                             id="service_based_invoice_verification"
                                                  checked={formValues.service_based_invoice_verification.value=='X'}
                                                  onChange={(e) => handleFormChange('service_based_invoice_verification', e.target.checked? 'X':'')}
                                                  style={{ marginLeft: '8px' }}
                                                />
                          
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Purchase Organization*
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('porg', 'purchase_organization')}>
                            
                           <SoftInput
                             name="witholding_tax"
                             id="witholding_tax"
                             readOnly
                             value={formValues.purchase_organization.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                      
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Type 5
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('taxtype', 'tax_type_5')}>
                            
                           <TextField
  name="tax_type"
  id="tax_type"
  // value={selectedVendor?.msme_registration_no
  // }
  disabled
  szie="medium"
  // onChange={(e) => handleFormChange('tax_type', e.target.value)}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Typography sx={{ fontSize: '15px' }}>IN5</Typography>
      </InputAdornment>
    ),
  }}
  variant="outlined"
/>
                           </div>
                         </SoftBox>
                       </Grid> */}
                       
                       {/* <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Tax Number 5
                             </SoftTypography>
                           </SoftBox>
                       
                            
                           <SoftInput
                             name="tax_number_5"
                             id="tax_number_5"
                             value={ formValues.tax_number_5.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                             onChange={(e) => handleFormChange('tax_number_5', e.target.value)}
                             
                           />
                          
                         </SoftBox>
                       </Grid> */}
                       

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Order Currency*.
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('ordrcurr','order_currency')}>
                            
                           <SoftInput
                             name="order_currency"
                             id="order_currency"
                             readOnly
                             value={formValues.order_currency.value}
                            //  error={formValues.tds_exemption.error}
                             // value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Schema Group Supplier
                             </SoftTypography>
                           </SoftBox>
                           <div onClick={() => handleDropdownClick('schema','vendor_schema')}>
                            
                           <SoftInput
                            disabled
                             name="schema"
                             id="schema"
                             value={formValues.vendor_schema.value}
                            //  error={formValues.tds_exemption.error}
                            //  value={formValues.tds_exemption.value}
                            //  onChange={(e) => handleFormChange('tds_exemption', e.value)}
                             
                           />
                           </div>
                         </SoftBox>
                       </Grid>

                </Grid>
                </SoftBox>
                </CardContent>
                <SoftButton type="submit" color="success" variant="contained" mt={1}>Submit</SoftButton>
              </Card>
            </form>
          ):(
            <>
            </>
          )}
        </DialogContent>
      </Dialog>
       <Dialog open={openComment} onClose={()=>setOpenComment(false)} maxWidth="xs" fullWidth>
        <SimpleBackdrop openLoader={isActive}/>
                  <DialogTitle>Comment</DialogTitle>
                  <DialogContent>
                      <TextareaAutosize
                      onChange={(e) => setComment(e.target.value)}
                          minRows={3}
                          placeholder="Write your comment..."
                          style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                      />
                      <SoftButton onClick={finishApproval}  color="success" variant="contained" mt={1}>Submit</SoftButton>
                  </DialogContent>
              </Dialog>
      
              <Dialog open={openComment2} onClose={()=>setOpenComment2(false)} maxWidth="xs" fullWidth>
                <SimpleBackdrop openLoader={isActive}/>
                  <DialogTitle>Comment</DialogTitle>
                  <DialogContent>
                      <TextareaAutosize
                      onChange={(e) => setComment(e.target.value)}
                          minRows={3}
                          placeholder="Write your comment..."
                          style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                      />
                      <SoftButton onClick={finishReject} color="success" variant="contained" mt={1}>Submit</SoftButton>
                  </DialogContent>
              </Dialog>

               <Dialog open={openComment3} onClose={()=>setOpenComment3(false)} maxWidth="xs" fullWidth>
                <SimpleBackdrop openLoader={isActive}/>
                  <DialogTitle>Comment</DialogTitle>
                  <DialogContent>
                      <TextareaAutosize
                      onChange={(e) => setComment(e.target.value)}
                          minRows={3}
                          placeholder="Write your comment..."
                          style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                      />
                      <SoftButton onClick={finishRework} color="success" variant="contained" mt={1}>Submit</SoftButton>
                  </DialogContent>
              </Dialog>

              
                      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                        <SimpleBackdrop openLoader={searchLoader}/>
                <DialogTitle>Select an Option</DialogTitle>
                <DialogContent>

                <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "5px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        />
         <SoftButton
      onClick={() => handleFormChange(selectedField, "")}
      style={{
        marginBottom: "10px",
        backgroundColor: "#ccc",
        border: "none",
        padding: "5px 10px",
        fontSize: "12px",
        cursor: "pointer",
        borderRadius: "4px"
      }}
    >
      Clear Selection
    </SoftButton>
                <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                <thead>
                <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {keySelected &&
                        filteredData?.map((item, index) => (
                          <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange(selectedField,item.value)}>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </DialogContent>
              </Dialog>

              <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
                <SimpleBackdrop openLoader={isActive}/>
                <DialogTitle>Select an Option</DialogTitle>
                <DialogContent>

                <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "5px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        />
         <SoftButton
      onClick={() => handleFormChange(selectedField, "", indexSelected)}
      style={{
        marginBottom: "10px",
        backgroundColor: "#ccc",
        border: "none",
        padding: "5px 10px",
        fontSize: "12px",
        cursor: "pointer",
        borderRadius: "4px"
      }}
    >
      Clear Selection
    </SoftButton>
                <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                <thead>
                <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {keySelected &&
                        filteredData?.map((item, index) => (
                          <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => handleFormChange(selectedField,item.value,indexSelected)}>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </DialogContent>
              </Dialog>
    </DashboardLayout>
  )
}


export default VendorsList